/** Case-insensitive, trimmed equality between two display names. */
export const isSamePerson = (a: string, b: string) =>
  a.trim().toLowerCase() === b.trim().toLowerCase();
